import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { ResultSummary } from '../common/ResultSummary';
import { shortDate } from '../rpat/assessmentResult';

// Shown right after a Job Simulation final verdict: which job, which step, the final score and pass status
export const FinalResultDialog = ({ result, onClose }) => (
    <Dialog open={!!result} onOpenChange={(open) => !open && onClose()}>
        <DialogContent className="max-w-lg bg-background" data-testid="job-final-result-dialog">
            <DialogHeader>
                <DialogTitle>{result?.passed ? 'Final Assessment passed' : 'Final Assessment result'}</DialogTitle>
                <DialogDescription>Result of the job simulation you just completed.</DialogDescription>
            </DialogHeader>
            {result && (
                <ResultSummary
                    testId="job-final-result"
                    path={['Job Simulations', result.skillName]}
                    title="Final Assessment · Candidate verdict"
                    score={result.score}
                    status={result.passed ? { label: 'Passed', tone: 'passed' } : { label: 'Not passed · retake to improve', tone: 'failed' }}
                    details={[
                        { label: 'Your verdict', value: result.verdict === 'good_fit' ? 'Good fit' : 'Not a good fit' },
                        { label: 'Verdict was', value: result.verdictCorrect ? 'Correct' : 'Incorrect' },
                        { label: 'Pass mark', value: `${result.passMark}%` },
                        { label: 'Overall job score', value: result.overallSkillScore != null ? `${result.overallSkillScore}%` : null },
                        { label: 'Jobs passed', value: result.jobsRequired ? `${result.jobsCompleted} of ${result.jobsRequired}` : null },
                        { label: 'Completed', value: shortDate(result.completedAt) },
                    ]}
                />
            )}
            {result?.feedback && (
                <p className="max-h-40 overflow-y-auto text-sm text-muted-foreground" data-testid="job-final-result-feedback">{result.feedback}</p>
            )}
            <DialogFooter>
                <Button onClick={onClose} data-testid="job-final-result-close">{result?.passed ? 'Continue' : 'Back to job'}</Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
);
